import axios from "axios";
import { API_URL } from "../config";
import { APP_BASENAME, paths } from "../paths";

export const adminApi = axios.create({
  baseURL: `${API_URL}/admin-api`,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On an expired/invalid admin token, clear it and bounce to the admin login
// instead of leaving the admin soft-locked on a generic error screen.
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("adminToken");
      window.location.href = `${APP_BASENAME}${paths.adminLogin}`;
    }
    return Promise.reject(error);
  }
);
